import React, {useEffect, useState} from 'react';
import {IGlobalStorefrontSettings, IStorefrontSettings} from '../../models/Storefront';

import ToggleField from "../Common/ToggleField";
import RichTextField from "../Common/RichTextField";
import {Dropdown, IDropdownOption} from "@fluentui/react";
import {useGetOrganizationQuery} from "../../store/endpoints/OrganizationsEndpoints";
import {useSelector} from "react-redux";
import {RootState} from "../../store/rootReducer";

interface IStorefrontSettingsFormProps {
    globalSettings?: IGlobalStorefrontSettings;
    settings: IStorefrontSettings;
    onChange: (settings: IStorefrontSettings) => void;
    onLoading?: (isLoading: boolean) => void;
}

const StorefrontAccessSettingsForm: React.FC<IStorefrontSettingsFormProps> = (props) => {
    const [repOptions, setRepOptions] = useState<IDropdownOption[]>([]);
    const selectedOrg = useSelector((state: RootState) => state.settings.selectedOrganization);
    const org = useGetOrganizationQuery(selectedOrg ?? '', {skip: !selectedOrg || selectedOrg === ''});
    useEffect(() => {
        if(org.data){
            const options = org.data.users?.map((u) => ({
                key: u.username ?? '',
                text: u.username ?? ''
            }))
            setRepOptions(options ?? []);
        }
    }, [org.data]);
    return (
        <div>
            <h3>Settings</h3>
            <ToggleField inline={true} label='Allow Anonymous Browsing' toolTip={'Allow guest users without known contact details to browse the storefront. These users will not be able to add to cart, view order, or place orders'} checked={props.settings.allowAnonymousAccess} onChange={(e, c) => props.onChange({...props.settings, allowAnonymousAccess: c})} />
            {props.settings.allowAnonymousAccess &&
                <React.Fragment>
                    <ToggleField inline={true} label='Show Pricing For Anonymous Users'  checked={props.settings.anonymousShowPricing} onChange={(e, c) => props.onChange({...props.settings, anonymousShowPricing: c})} />
                </React.Fragment>
            }
            <ToggleField inline={true} label='Allow Signup' checked={props.settings.allowSignup} onChange={(e, c) => props.onChange({...props.settings, allowSignup: c})} />
            {props.settings.allowSignup &&
                <div>
                    <RichTextField label={'Signup Terms and Conditions'} mode={"markdown"} value={props.settings.signupTermsAndConditions} toolTip={'Markdown allowed'} onChange={( c) => props.onChange({...props.settings, signupTermsAndConditions: c})}></RichTextField>
                </div>
            }
            <ToggleField inline={true} label='Allow Previous Addresses' checked={props.settings.allowPreviousAddresses} onChange={(e, c) => props.onChange({...props.settings, allowPreviousAddresses: c})} />
            <ToggleField inline={true} label='Allow Cart Sharing' checked={props.settings.allowCartSharing} onChange={(e, c) => props.onChange({...props.settings, allowCartSharing: c})} />
            <ToggleField inline={true} label='Allow Quote Request' checked={props.settings.allowRequestQuote} onChange={(e, c) => props.onChange({...props.settings, allowRequestQuote: c})} />
            {props.settings.allowRequestQuote && 
            <div style={{marginLeft: '1em'}}>
                <Dropdown
                    required={true}
                    label="Contact for Quote Requests"
                    options={repOptions}
                    selectedKey={props.settings?.defaultSalesRep}
                    onChange={(_, option) => props.onChange({...props.settings, defaultSalesRep: option?.key as string ?? ""})}
                />
            </div>
            }



        </div>
    );
}

export default StorefrontAccessSettingsForm;